"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", [_c("span", {
    on: {
      click: _vm.handleOpen
    }
  }, [_vm._t("trigger", function () {
    return [_c("a-button", [_vm._v("导出")])];
  })], 2), _c("a-modal", {
    attrs: {
      title: "导出",
      "destroy-on-close": "",
      "confirm-loading": _vm.loading,
      width: "1000px",
      "body-style": {
        height: "500px"
      }
    },
    on: {
      ok: _vm.close,
      cancel: _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("ys-async-export-table", {
    ref: "tableRef",
    attrs: {
      "export-fn": _vm.exportFn,
      columns: _vm.columns,
      "biz-type": _vm.bizType,
      "table-wrapper-class": "!p-0"
    },
    scopedSlots: _vm._u([{
      key: "export",
      fn: function () {
        return [_vm._t("export", function () {
          return [_c("a-button", {
            attrs: {
              type: "primary",
              loading: _vm.loading
            },
            on: {
              click: _vm.handleExport
            }
          }, [_vm._v("导出")])];
        }, null, {
          exportFn: _vm.handleExport,
          loading: _vm.loading
        })];
      },
      proxy: true
    }], null, true)
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;